import { ClientDataType } from "@/api/ClientApi";
import { ClientRelatedAttributes } from "@/formTypes/ClientFormDataType";
import { buildImportPayload as buildPayload } from "./core/payload";
import { ImportAction, ImportPayloadRow } from "./core/types";
import { ResolvedRow } from "./resolveImportRows";

export type { ImportAction, ImportPayloadRow };

/**
 * Atributos que no viajan a la lambda: son relaciones que el formulario carga para
 * mostrar, no columnas del modelo.
 */
const RELATION_ATTRIBUTES = new Set<string>(ClientRelatedAttributes as string[]);

/** Convierte las filas resueltas en el payload que espera la lambda de importacion. */
export const buildImportPayload = (rows: ResolvedRow[]): ImportPayloadRow[] =>
    buildPayload<ClientDataType & object>(rows, RELATION_ATTRIBUTES);
